import { z } from 'zod';

export const getScalesSchema = z.object({
  search: z.string().optional(),
  limit: z
    .string()
    .optional()
    .default('50')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
});

export const getScaleSchema = z.object({
  scale_id: z.uuid('Invalid scale ID'),
});

export const deleteScaleSchema = z.object({
  scale_id: z.uuid('Invalid scale ID'),
});

export type GetScalesPayload = z.infer<typeof getScalesSchema>;
export type GetScalePayload = z.infer<typeof getScaleSchema>;
export type DeleteScalePayload = z.infer<typeof deleteScaleSchema>;
